"use client";

import DynamicIcon from "./DynamicIcon";

interface RichFeatureGridProps {
  title: string;
  description: string;
  items: {
    icon: string;
    title: string;
    description: string;
  }[];
}

export default function RichFeatureGrid({ title, description, items }: RichFeatureGridProps) {
  return (
    <section className="py-24 container mx-auto px-4">
      <div className="text-center mb-16">
        <h2 className="text-3xl md:text-5xl font-bold mb-6 tracking-tighter">{title}</h2>
        <p className="text-muted-foreground text-lg max-w-2xl mx-auto">{description}</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {items.map((item, idx) => (
          <div
            key={idx}
            className="group p-8 rounded-3xl border border-border bg-card hover:border-primary/50 hover:shadow-lg transition-all duration-300"
          >
            <div className="w-14 h-14 rounded-2xl bg-primary/10 text-primary flex items-center justify-center text-3xl mb-6 group-hover:scale-110 group-hover:bg-primary group-hover:text-primary-foreground transition-all duration-300">
              <DynamicIcon name={item.icon} />
            </div>
            <h3 className="text-xl font-bold mb-3 group-hover:text-primary transition-colors">
              {item.title}
            </h3>
            <p className="text-muted-foreground leading-relaxed">{item.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
